import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '8px'
  },
  statusIconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  statusIcon: {
    width: '15px',
    height: '15px',
    borderRadius: '50%'
  },
  completed: {
    background: theme.palette.transactions.status.completed
  },
  pending: {
    background: theme.palette.transactions.status.pending
  },
  cancelled: {
    background: theme.palette.transactions.status.cancelled
  },
  declined: {
    background: theme.palette.transactions.status.declined
  }
}));
